import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { PolicyComponent } from "@idw-types/data/reference-data/generic/policy-component";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { handleRequestWithBody } from "@utils/http-util";

type CreatePolicyComponentRequestResponse = {
    response: PolicyComponent;
};

export const createPolicyComponentRequest = async (
    body: PolicyComponent
): Promise<GenericNetworkResponse<CreatePolicyComponentRequestResponse>> => {
    const route = apiRoutes.serviceConfiguration.data.deployedpolicycomponent;
    const { data, error } = await handleRequestWithBody(RequestTypes.POST, route, body);
    return { data, error, body };
};